module.exports = __webpack_public_path__ + "img/title-3.8ef18e18.png";